import {Sprite, Texture} from 'pixi.js';
import {Component, ComponentProps} from './components/Component';
import {ResourceLoader} from '@gongxigames/framework/core/services/resourceLoader/ResourceLoader';
import {LanguageService} from '@gongxigames/framework/core/services/LanguageService';

export type Platform = 'desktop'|'mobile';

export type Resources = {
    shared_sprite: Record<string, Readonly<Component<ComponentProps>>>;
    game_sprite: Record<string, Readonly<Component<ComponentProps>>>;
};

export interface DataBridge {
    resolution: number;
    getTexture(name: string): Texture | undefined;
    getLocalization(name: string): string | undefined;
    getPlatform(): Platform;
    getLoader(): ResourceLoader;
    getLanguageService(): LanguageService;
    updateResources(resources: Resources): void;
}

export type Context = DataBridge & {
    attachToReloadId<T extends Sprite>(id: string, item: T): void;
};
